"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeaderTitle = void 0;
var Categories_1 = require("icf-search-client-shared/lib/constants/Categories");
var decodeQuery = function (isLoadingInitialResults, query) {
    if (isLoadingInitialResults) {
        return "\xA0"; //Non-breaking space as layout placeholder
    }
    else {
        var decodedQuery = query;
        try {
            decodedQuery = decodeURIComponent(query);
        }
        catch (err) {
            // This is annoying, and should perhaps send some kind of event, but for now it silently ignores the err.
            // When errors occur, the query will be passed through as is.
        }
        return "\"".concat(decodedQuery, "\"");
    }
};
var getHeaderTitle = function (props) {
    var _a, _b;
    var _c = props.resultsContext, isFallback = _c.isFallback, isLoadingInitialResults = _c.isLoadingInitialResults, totalItemCount = _c.totalItemCount;
    var currentCategory = props.currentCategory, isFirstGrid = props.isFirstGrid, queryOptions = props.queryOptions, isOverFiltered = props.isOverFiltered, translate = props.translate, ageVerificationRules = props.ageVerificationRules;
    if (isFirstGrid !== undefined && !isFirstGrid) {
        return { message: translate("search.you_might_like") };
    }
    var isTextBlurEnabled = ageVerificationRules === null || ageVerificationRules === void 0 ? void 0 : ageVerificationRules.isTextBlurEnabled;
    // NOTE: this is to render "All Trans Cams" instead of "All Live Cams" for SM & whitelabels with this xment on
    var isSearchTransTabMobileEnabled = ((_b = (_a = props.xmentService) === null || _a === void 0 ? void 0 : _a._xment) === null || _b === void 0 ? void 0 : _b.searchTransTabMobile) === "ON";
    // TODO: Need to be checking on the queryoptions type like below
    var category = isSearchTransTabMobileEnabled && currentCategory === "alltrans" && queryOptions.category === "allcams"
        ? "categories.".concat(currentCategory)
        : "categories.".concat(queryOptions.category);
    switch (queryOptions.type) {
        case "favorites":
            if (!isOverFiltered && (isFallback || (!isLoadingInitialResults && totalItemCount === 0))) {
                return { message: translate("search.no_favorites_header") };
            }
            return { message: translate("categories.favorites") };
        case "category":
            return {
                message: translate(category),
                blurMessage: isTextBlurEnabled &&
                    !["new", "gold", "recents"].includes(String(queryOptions.category).toLowerCase()),
            };
        case "keyword":
            return {
                message: decodeQuery(isLoadingInitialResults, queryOptions.keyword),
                blurMessage: isTextBlurEnabled,
            };
        case "tag":
            return { message: decodeQuery(isLoadingInitialResults, queryOptions.tag), blurMessage: isTextBlurEnabled };
        case "browse":
            return {
                message: currentCategory != null && (0, Categories_1.isCategoryInDisplayMap)(currentCategory)
                    ? translate("categories.".concat(currentCategory))
                    : translate("categories.allcams"),
            };
    }
    return null;
};
exports.getHeaderTitle = getHeaderTitle;
//# sourceMappingURL=SearchResultsSectionHeaderTitle.js.map